// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'semitruck-solid';

export const Component = () => (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M1 7h15v9h-.063a2 2 0 0 1-3.437.823A2 2 0 0 1 9.063 16H7.937a2 2 0 0 1-3.437.823A2 2 0 0 1 1.063 16H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm11 8.496v.007a1 1 0 1 1 0-.007zm1 .008a1 1 0 1 0 0-.008v.004zM5 15.5v.004a1 1 0 1 0 0-.007zm-2-1a1 1 0 0 1 1 .997v.007A1 1 0 1 1 3 14.5zM24 16h-1.063a2 2 0 0 1-3.874 0H17V7h.665a1 1 0 0 1 .872.51l.551.98a1 1 0 0 0 .872.51h.603a1 1 0 0 1 .8.4l1.65 2.2a1 1 0 0 0 .8.4H24a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm-4-6h.563l1.5 2H20zm1 4.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'
  />
);

export const viewBox = '0 0 25 25';
